import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppVersionComponent } from '../app-version/app-version.component';

@Component({
  selector: 'app-sidebar-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AppVersionComponent],
  template: `
    <a>
      <div class="lpx-brand-logo"></div>
    </a>
    <app-version />
  `,
  encapsulation: ViewEncapsulation.None,
})
export class SidebarLogoComponent {
  homeUrl = environment.homeUrl;
}
